if (!customElements.get('progress-bar')) {
    customElements.define(
      'progress-bar',
      class ProgressBar extends HTMLElement {
        constructor() {
            super();
            this.thresholds = this.querySelectorAll('[data-threshold]');
            this.progressMarkerItem = this.querySelector('.progress-bar-marker');
            this.thresholdMessages = this.querySelectorAll('.progress-messages p');
            this.amountRemainingMessage = this.querySelector('[data-amount-left-message]');
            //this.getCart();
        }

        connectedCallback() {
          //this.progressMarker();
          this.positionMarker(this.progressMarkerItem.dataset.percentage);
          document.addEventListener('theme:cart:change',(event)=>{
            this.amountRemaining(event);
            this.progressStatus(event);
            this.thresholds.forEach((threshold, index) => {

              
              const thresholdValue = parseFloat(threshold.dataset.threshold);

    
              if(thresholdValue < this.getCartTotal(event)) {
                this.thresholdMessages[index].classList.add('activated-message');
                threshold.closest('.progress-bar-item').classList.add('completed-bar');
                threshold.closest('.progress-bar-item').classList.remove('current-bar');

  
                if(this.thresholds[index+1]) {
                  this.thresholds[index+1].closest('.progress-bar-item').classList.add('current-bar');
                }
              } else {
                this.thresholdMessages[index].classList.remove('activated-message');
                threshold.closest('.progress-bar-item').classList.remove('completed-bar');
                if(this.thresholds[index+1]) {
                  this.thresholds[index+1].closest('.progress-bar-item').classList.remove('current-bar');
                }
              }

              if(this.getCartTotal(event) <  parseFloat(this.thresholds[this.thresholds.length - 1].dataset.threshold)) {
                this.thresholds[0].closest('.progress-bar-item').classList.add('current-bar');
                this.progressMarker(event);
              }  

              if(threshold.closest('.progress-bar-item').classList.contains('current-bar')) {
                const amountRemaining = (thresholdValue - this.getCartTotal(event)) / 100;
                const thresholdMessage = this.thresholdMessages[index].dataset.msg;
                const msg = this.amountRemainingMessage.dataset.amountLeftMessage.replace('__amount__', '$' + amountRemaining).replace('__message__', thresholdMessage);
                this.amountRemainingMessage.innerHTML = msg;
              }

            });
          });
        }
        progressMarker(event) {
          const lastThreshold = parseFloat(this.thresholds[this.thresholds.length - 1].dataset.threshold);
          const cartTotal = this.getCartTotal(event);
          if(lastThreshold >= cartTotal) {
            const percentage = (cartTotal / lastThreshold) * 100;
            this.positionMarker(percentage);
            this.progressMarkerItem.innerHTML='$' + cartTotal / 100;
          }            
        }
        positionMarker(percentage) {
          const widthHalf = this.progressMarkerItem.offsetWidth / 2;
          this.progressMarkerItem.style.left = `calc(${percentage}% - ${widthHalf}px)`;
        }

        progressStatus(event) {
          const lastThreshold = parseFloat(this.thresholds[this.thresholds.length - 1].dataset.threshold);
          const cartTotal = this.getCartTotal(event);
          const progressBarInner  = document.querySelector('.progress-bar-inner');
          const thresholdCompleteMessage = document.querySelector('.threshold-complete-message');
          console.log(lastThreshold, cartTotal);
          if(lastThreshold > cartTotal) {
            progressBarInner.classList.remove('hidden');
            thresholdCompleteMessage.classList.add('hidden');
          } else {
            progressBarInner.classList.add('hidden');
            thresholdCompleteMessage.classList.remove('hidden');

          }
        }

        amountRemaining(event) {
          const lastThreshold = parseFloat(this.thresholds[this.thresholds.length - 1].dataset.threshold);
          const amountRemaining = (lastThreshold - this.getCartTotal(event)) / 100;
          const msg = this.amountRemainingMessage.dataset.amountLeftMessage.replace('__amount__', '$' + amountRemaining);
          this.amountRemainingMessage.innerHTML = msg;
        }


        getCartTotal(event) {
            return event.detail.cartTotal;
          }
      }
    );
}